export default "__VITE_ASSET__DfQ9bRs8__"